
import Typography from '@mui/material/Typography';
import { useRapportFont } from './RapportFontContext';

interface IRapportTypographyProps
  extends React.ComponentProps<typeof Typography> {
  Size?: number;
  Height?: number;
  Style?: string;
}

const defaultFontFamily = 'Calibri, Arial, sans-serif';

export const getTypographyStyle = (
  Size?: number,
  Height?: number,
  Style?: string,
  isMultiline?: boolean,
  contextFont?: string
) => {
  const fontSize = `${Math.floor((Size ?? 11) * 1.4)}px`;
  const lineHeight = isMultiline
    ? '1.2'
    : (Height ?? 1.5) * (Size ?? 11) + 'px';
  const isBold = Style?.includes('b');
  const isItalic = Style?.includes('i');
  const isUnderline = Style?.includes('u');
  return {
    fontFamily: contextFont
      ? `${contextFont}, ${defaultFontFamily}`
      : defaultFontFamily,
    lineHeight,
    fontSize,
    fontWeight: isBold ? 'bold' : 'normal',
    fontStyle: isItalic ? 'italic' : 'normal',
    textDecoration: isUnderline ? 'underline' : 'none',
  };
};

// Wrapper för MUI Typography
const RapportTypography: React.FC<IRapportTypographyProps> = ({
  Size,
  sx,
  Height,
  Style,
  ...props
}) => {
  const contextFont = useRapportFont();
  return (
    <Typography
      sx={{
        ...getTypographyStyle(Size, Height, Style, false, contextFont),
        ...sx,
      }}
      {...props}
    />
  );
};

export default RapportTypography;
